import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n"; // Este va aquí arriba
import HomeV2 from "./redesign/home/HomeV2";
import AboutPage from "./redesign/about/AboutPage";
import AdminRegistrations from "./redesign/admin/AdminRegistrations";
import AdminMetricsDashboard from "./redesign/admin/AdminMetricsDashboard";
import AdminBlogPage from "./redesign/admin/AdminBlogPage";
import AdminMediaDirectory from "./redesign/admin/AdminMediaDirectory";
import AdminLeaderboardsPage from "./redesign/admin/AdminLeaderboardsPage";
import AdminGamergyOps from "./redesign/admin/AdminGamergyOps";
import AdminAccessGate from "./redesign/admin/AdminAccessGate";
import TournamentOpsAccessGate from "./redesign/tournament-ops/TournamentOpsAccessGate";
import TournamentOpsGamergy from "./redesign/tournament-ops/TournamentOpsGamergy";
import RegistrationPage from "./redesign/registration/RegistrationPage";
import BlogListPage from "./redesign/blog/BlogListPage";
import BlogPostPage from "./redesign/blog/BlogPostPage";
import EventsPage from "./redesign/events/EventsPage";
import ComicConPage from "./redesign/events/ComicConPage";
import LeaderboardsPage from "./redesign/leaderboards/LeaderboardsPage";
import PartnersPage from "./redesign/partners/PartnersPage";
import ShowPage from "./redesign/show/ShowPage";
import FaqPage from "./redesign/faq/FaqPage";
import PressPage from "./redesign/press/PressPage";
import PartnerInquiryPage from "./redesign/partners/PartnerInquiryPage";
import SelectedWorkPage from "./redesign/work/SelectedWorkPage";
import ContactPage from "./redesign/contact/ContactPage";
import PrivacyPage from "./redesign/legal/PrivacyPage";
import TermsPage from "./redesign/legal/TermsPage";
import WhatIsPrelPage from "./redesign/what/WhatIsPrelPage";
import EsportsInPuertoRicoPage from "./redesign/what/EsportsInPuertoRicoPage";
import ShopPreviewPage from "./ShopPreviewPage";

const path = window.location.pathname;
const isAdminPath = path.startsWith("/admin/");
const isTournamentOpsPath = path.startsWith("/tournament-ops");

const App = path.startsWith("/admin/registros")
  ? AdminRegistrations
  : path.startsWith("/admin/dashboard")
    ? AdminMetricsDashboard
    : path.startsWith("/admin/blog")
      ? AdminBlogPage
      : path.startsWith("/admin/media")
        ? AdminMediaDirectory
        : path.startsWith("/admin/leaderboards")
            ? AdminLeaderboardsPage
            : path.startsWith("/admin/gamergy")
              ? AdminGamergyOps
            : path.startsWith("/registro")
        ? RegistrationPage
        : path.startsWith("/enc26")
          ? HomeV2
          : path.startsWith("/tournament-ops")
            ? TournamentOpsGamergy
          : path.startsWith("/leaderboards")
            ? LeaderboardsPage
            : path === "/partners"
              ? PartnersPage
            : path === "/the-show"
              ? ShowPage
            : path === "/faq"
              ? FaqPage
            : path === "/press"
              ? PressPage
            : path === "/for-partners"
              ? PartnerInquiryPage
            : path === "/contacto"
              ? ContactPage
            : path === "/privacidad"
              ? PrivacyPage
            : path === "/terminos"
              ? TermsPage
            : path === "/selected-work"
              ? SelectedWorkPage
            : path === "/prcc-2026"
              ? ComicConPage
            : path === "/shop-preview" || path === "/merch"
              ? ShopPreviewPage
            : path === "/eventos"
              ? EventsPage
            : path === "/quienes-somos"
              ? AboutPage
            : path === "/que-es-prel"
              ? WhatIsPrelPage
            : path === "/esports-en-puerto-rico"
              ? EsportsInPuertoRicoPage
          : path === "/blog"
            ? BlogListPage
            : path.startsWith("/blog/")
              ? BlogPostPage
              : HomeV2;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isAdminPath ? (
      <AdminAccessGate>
        <App />
      </AdminAccessGate>
    ) : isTournamentOpsPath ? (
      <TournamentOpsAccessGate>
        <App />
      </TournamentOpsAccessGate>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
